import Footer from "../components/footer";
import Header from "../components/header";
import HeroSec from "../components/hero";

export default function LandingPage() {
  return (
    <>
      <Header />
      <HeroSec />
      <Footer />
    </>
  );
}
